var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLightBackground(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 578.923,
    height: 1000,
    viewBox: "0 0 578.923 1000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Path_21198",
    "data-name": "Path 21198",
    fill: "#042",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 481.7774047851562 999.5 L 0.4999563097953796 999.5 L 0.4999563097953796 0.5 L 578.372314453125 0.5 L 481.7774047851562 999.5 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 0.99993896484375 1 L 0.99993896484375 999 L 481.3232116699219 999 L 577.8215942382812 1 L 0.99993896484375 1 M -6.103515625e-05 0 L 578.9229736328125 0 L 482.231201171875 1000 L -6.103515625e-05 1000 L -6.103515625e-05 0 Z",
    stroke: "none",
    fill: "#707070"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightBackground);
export default __webpack_public_path__ + "static/media/light_background.36eda370533f6974f6d0ae8b2f10a051.svg";
export { ForwardRef as ReactComponent };